import { render, staticRenderFns } from "./ReportRx.vue?vue&type=template&id=1bad5850&scoped=true&"
import script from "./ReportRx.vue?vue&type=script&lang=js&"
export * from "./ReportRx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad5850",
  null
  
)

export default component.exports